import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initNative } from './lib/native-init'

// Capacitor boot path: the native shell loads capacitor://localhost/index.html
// (the marketing landing), which then redirects to /app.html to hand off to
// the SPA. But now window.location.pathname === "/app.html" and React Router
// has no matching route → renders NotFound. Rewrite the URL to "/" so the
// Home route (which then redirects to /welcome for logged-out users) picks
// up correctly. Uses replaceState so back-nav doesn't return to /app.html.
if (
  typeof window !== "undefined" &&
  (window.location.pathname === "/app.html" ||
    window.location.pathname.endsWith("/app.html"))
) {
  window.history.replaceState(
    null,
    "",
    "/" + window.location.search + window.location.hash,
  );
}

// Fire-and-forget — native plugins should never block the React render.
initNative().catch(() => undefined)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
